import React, { useMemo, memo, useEffect } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Annotation from 'chartjs-plugin-annotation';

import { createOptions } from './VerticalBarsUtils';

ChartJS.register(CategoryScale, LinearScale, BarElement, ChartDataLabels, Tooltip, Legend, Annotation);

function VerticalBars({ height, data, config }) {
  const theme = useSelector((state) => state.global.theme);

  const options = useMemo(() => {
    return createOptions({ theme, data, config });
  }, [theme, data, config]);

  //fix tooltip on unmount
  useEffect(() => {
    return () => {
      const tooltip = document.getElementById('chartJsVerticalBarsTooltip');
      if (tooltip) {
        tooltip.remove();
      }
    };
  }, []);

  return (
    <div style={{ height, width: '100%' }}>
      <Bar options={options} data={data} />
    </div>
  );
}

export default memo(VerticalBars);
